"use strict";
/** @license See the LICENSE file. */
Object.defineProperty(exports, "__esModule", { value: true });
// This code is auto-generated, do not modify this file!
var version = '0.8.4';
exports.version = version;
//# sourceMappingURL=version.js.map